import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { OptionsFiltersPrefererence, UserReportSettingsState } from 'models/userReportSettings';

export const initialState: UserReportSettingsState = {
  optionsFilterPreference: [],
  selectedFilterPreference: null,
};

export const slice = createSlice({
  name: 'userReportSettings',
  initialState,
  reducers: {
    setDefaultState: () => initialState,
    setOptionsFilterPreference: (state, { payload }: PayloadAction<OptionsFiltersPrefererence[]>) => {
      state.optionsFilterPreference = payload;
    },
    setSelectedFilterPreference: (state, { payload }: PayloadAction<OptionsFiltersPrefererence | null>) => {
      state.selectedFilterPreference = payload;
    },
  },
});

export default slice.reducer;
